import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EntityTypeIds } from '../../constants.new';
import { CsrCommandCenterRepository } from './csrCommandCenter.repository';

@Injectable()
export class CsrCommandCenterService {
    constructor(
        private readonly _http: HttpClient,
        private readonly csrRepo: CsrCommandCenterRepository,
    ) {}

    entityCharacteristics: Core.ClientServiceResponsibilityCommandCenterDescriptorInfoModel = null;

    private readonly _baseUrl = 'api/clientserviceresponsibility/cc/';

    search(
        groupSearchModel: Core.ClientServiceResponsibilityCommandCenterSearchModel,
    ): Promise<Compliance.QueryResultModel<Core.ClientServiceResponsibilityCommandCenterModel>> {
        return lastValueFrom(this._http.post(`${this._baseUrl}search/`, groupSearchModel)) as Promise<
            Compliance.QueryResultModel<Core.ClientServiceResponsibilityCommandCenterModel>
        >;
    }

    searchRowIds(
        groupSearchModel: Core.ClientServiceResponsibilityCommandCenterSearchModel,
    ): Promise<Compliance.QueryResultModel<Core.ClientServiceResponsibilityCommandCenterRowInfo>> {
        return lastValueFrom(this._http.post(`${this._baseUrl}search/rowids`, groupSearchModel)) as Promise<
            Compliance.QueryResultModel<Core.ClientServiceResponsibilityCommandCenterRowInfo>
        >;
    }

    removeExceptions(model: Core.ClientServiceExceptionRemoveRequest): Promise<boolean> {
        return lastValueFrom(this._http.put(`${this._baseUrl}exception/remove`, model)) as Promise<boolean>;
    }

    async exportList(exportModel: Core.ClientServiceResponsibilityCommandCenterExportModel): Promise<number> {
        return await lastValueFrom(this.csrRepo.exportList(exportModel));
    }

    async getExport(longRunningProcessId: number): Promise<HttpResponse<Blob>> {
        return await lastValueFrom(this.csrRepo.getExport(longRunningProcessId));
    }

    async getEntityDescriptors(
        rootEntityIds: number[],
        rootEntityType: EntityTypeIds,
        excludeInactiveCompanies: boolean,
    ): Promise<Core.ClientServiceResponsibilityCommandCenterDescriptorInfoModel> {
        if (
            rootEntityType === EntityTypeIds.COMPANY ||
            rootEntityType === EntityTypeIds.SITE ||
            rootEntityType === EntityTypeIds.PARCEL
        ) {
            const request = this._http.post(`${this._baseUrl}descriptorInfo`, {
                rootEntityIds,
                rootEntityType,
                includeInactive: !excludeInactiveCompanies,
            });

            this.entityCharacteristics = await (lastValueFrom(
                request,
            ) as Promise<Core.ClientServiceResponsibilityCommandCenterDescriptorInfoModel>);
            return this.entityCharacteristics;
        } else {
            throw rootEntityType;
        }
    }
}
